export const NUVEM_CHAT_WAITLIST_URL = '/nuvem-chat/waitlist';

export const nuvemChatTags = {
  waitlist: 'waitlist',
} as const;

export const NuvemChatEndpoints = {
  addToWaitList: 'addToWaitList',
} as const;
